module.exports = __webpack_public_path__ + "img/HQ-PA10W1L_ALL.5750b636.jpg";